<template>
  <v-card class="d-flex flex-column">
    <data-table-alteracoes
      :items="items"
      :is-get-alteracoes-historico-loading="isGetAlteracoesHistoricoLoading"
      :select-item="selectItem"
    />

    <v-expand-transition>
      <alteracoes-list
        v-show="itemSelecionado.id && Object.keys(historico).length"
        :item-selecionado="itemSelecionado"
        :historico="historico"
        :is-get-historico-loading="isGetHistoricoLoading"
      />
    </v-expand-transition>
  </v-card>
</template>

<script>
import { ref, watch } from '@vue/composition-api'
import Vue from 'vue'
import DataTableAlteracoes from './DataTableAlteracoes.vue'
import AlteracoesList from './AlteracoesList.vue'
import TicketService from '@/services/modules/TicketService'

export default {
  components: {
    DataTableAlteracoes,
    AlteracoesList,
  },

  props: {
    ticketId: {
      type: Number,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
    isGetAlteracoesHistoricoLoading: {
      type: Boolean,
      required: true,
    },
  },

  setup(props) {
    const itemSelecionado = ref({ id: 0, usuarioAlteracao: '', dataCadasto: '' })
    const historico = ref({})

    const isGetHistoricoLoading = ref(false)
    async function getHistorico(date) {
      try {
        isGetHistoricoLoading.value = true
        historico.value = await TicketService.getTicketHistorico(props.ticketId, date)
        isGetHistoricoLoading.value = false
      } catch {
        isGetHistoricoLoading.value = false
        Vue.$toast.error('Não foi possível carregar o detalhe dessa alteração. Tente novamente.')
      }
    }
    async function selectItem(item) {
      if (itemSelecionado.value.id === item.id) return
      itemSelecionado.value = {
        id: item.id,
        usuarioAlteracao: item.usuarioAlteracao,
        dataCadastro: item.dataCadastro,
      }
      getHistorico(item.dataCadastro)
    }
    async function resetData() {
      itemSelecionado.value = { id: 0, usuarioAlteracao: '', dataCadasto: '' }
      historico.value = {}
    }
    watch(() => props.ticketId, resetData)

    return {
      itemSelecionado,
      historico,
      isGetHistoricoLoading,
      selectItem,
    }
  },
}
</script>
